import React, { FC, ReactNode } from "react";

import { Icon } from "~/components/atoms";

type Props = {
  children: ReactNode;
  title?: string;
};

export const FilterWrapper: FC<Props> = ({ children, title = "検索" }) => {
  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 mb-8">
      <h2 className="text-xl font-bold text-secondary-900 mb-6 flex items-center">
        <Icon
          icon="ioFunnelOutline"
          size="1.5rem"
          color="text-primary-600"
          className="mr-2"
        />
        {title}
      </h2>
      <div className="space-y-2">{children}</div>
    </div>
  );
};
